// extracted by mini-css-extract-plugin
module.exports = {"card":"CreditsCard_card__eldO5","success":"CreditsCard_success__uuZmE","actions":"CreditsCard_actions__SNFSp"};